<template>
  <div class="quote-details-display">
    <div class="row">
      <div class="col-md-12">
        <accordian-display
          :icon="'fa-user'"
          :title="`Quote Details: ${quote.reference}`"
          :defaultOpen="true">
          <tr>
            <td class="font-weight-bold">Address</td>
            <td>
              {{ quote.address }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Suburb</td>
            <td>
              {{ quote.suburb }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Postcode</td>
            <td>
              {{ quote.postcode }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">State</td>
            <td>
              {{ quote.state }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Actual Amount</td>
            <td>
              {{ quote.actualCost | toDollarAmount }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Queue Jumped Cost</td>
            <td>
              {{ quote.jumpQueueCost | toDollarAmount }}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Payment Completed</td>
            <td>
              <span :class="paymentStatus.class" class="badge">
                {{ paymentStatus.text }}
              </span>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Property Photos</td>
            <td>
              <div v-if="quote.QuotePropertyPhoto && quote.QuotePropertyPhoto.length" class="mt-2 row">
                <template v-for="image in quote.QuotePropertyPhoto">
                  <div class="col-lg-4 text-center" :key="image.uuid">
                    <img :src="S3_BUCKET_URL + image.objectKey" class="img-thumbnail img-fluid my-1 mr-2" />
                    <download-input
                      :options="{ permalink: 'downloadFile'}"
                      :value="{ objectKey: image.objectKey }" />
                  </div>
                </template>
              </div>
              <template v-else>
                No Photos Available
              </template>
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Work Order</td>
            <td>
              <download-input
                :disabled="quote.WorkOrder ? false : true"
                :options="{ button: true, permalink: 'downloadFile', label: 'Download' }"
                :value="{ objectKey: quote.WorkOrder ? quote.WorkOrder.objectKey : '' }" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Plan of Subdivision Number</td>
            <td>
              {{quote.planOfSubdivisionNumber ? quote.planOfSubdivisionNumber : 'N/A'}}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Number of Lots</td>
            <td>
              {{quote.lots ? quote.lots : 'N/A'}}
            </td>
          </tr>
          <tr v-if="!isMaintenancePlan">
            <td class="font-weight-bold">Number of Levels</td>
            <td>
              {{quote.levels ? quote.levels : 'N/A'}}
            </td>
          </tr>
          <tr v-if="isMaintenancePlan">
            <td class="font-weight-bold">Number of Owner Corporation</td>
            <td>
              {{quote.numberOfOC ? quote.numberOfOC: 'N/A'}}
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Plan Of Subdivision</td>
            <td>
              <download-input
                :disabled="quote.PlanOfSubdivision ? false : true"
                :options="{ button: true, permalink: 'downloadFile', label: 'Download' }"
                :value="{ objectKey: quote.PlanOfSubdivision ? quote.PlanOfSubdivision.objectKey : '' }" />
            </td>
          </tr>
          <tr>
            <td class="font-weight-bold">Additional Documents</td>
            <td>
              <amazon-media-multiple-input v-model="docs"/>
            </td>
          </tr>
          <tr>
            <td>
            </td>
            <td>
              <button @click="saveChanges" class="btn btn-primary upload-button" type="button">Save Changes</button>
            </td>
          </tr>
        </accordian-display>
      </div>
    </div>
  </div>
</template>

<script>
import AccordianDisplay from '@/components/displays/AccordianDisplay'
import DownloadInput from '@/components/inputs/DownloadInput'
import AmazonMediaMultipleInput from '@/components/inputs/AmazonMediaMultipleInput'
import Api from '@/vuex/api'
import { mapActions, mapGetters } from 'vuex'
import {
  S3_BUCKET_URL
} from '@/util/helpers'
import {
  LOAD_QUOTE
} from '@/vuex/types'
export default {
  name: 'QuoteDetailsDisplay',
  components: {
    AccordianDisplay,
    DownloadInput,
    AmazonMediaMultipleInput
  },
  data () {
    return {
      docs: [],
      S3_BUCKET_URL
    }
  },
  computed: {
    quote () {
      return {
        ...this.loadedQuote
      }
    },
    paymentStatus () {
      let badge = {
        text: 'Payment Pending',
        class: 'badge-warning'
      }
      if (this.quote.isPaymentDone) {
        badge.text = 'Payment Complete'
        badge.class = 'badge-success'
      }

      return badge
    },
    ...mapGetters([
      'loadedQuote'
    ]),
    isMaintenancePlan () {
      return this.quote.reference.charAt(this.quote.reference.length - 1) === 'M' || this.quote.reference.charAt(this.quote.reference.length - 1) === 'm'
    }
  },
  watch: {
    $route () {
      this[LOAD_QUOTE](this.$route.params.quoteUuid)
    },
    loadedQuote () {
      let docDetails = this.loadedQuote && this.loadedQuote.QuoteDocuments ? this.loadedQuote.QuoteDocuments : []
      this.docs = docDetails.map((doc) => {
        return {
          fileName: doc.fileName,
          fileType: doc.fileType,
          key: doc.objectKey
        }
      })
    }
  },
  mounted () {
    this[LOAD_QUOTE](this.$route.params.quoteUuid)
  },
  methods: {
    async saveChanges () {
      const api = new Api()
      await api.uploadQuoteDocs(this.loadedQuote.uuid, this.docs)
    },
    ...mapActions([
      LOAD_QUOTE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/displays/QuoteDetailsDisplay.vue